<template>
<div class="chapter">
<div class="inner_page">
<h1 class="title"><a id="page_i"></a><b>Coffins for Two</b></h1>
<p class="edit">Stories of Life, Death, Love, and Other Mysteries</p>
<p class="author">Vincent Starrett<a id="page_ii"></a></p>
<div class="img_container1">
<img alt="image" src="images/logo3.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 01_Title.vue?f2439d66